// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import error from '../../../../common/nodejs/errors';
import config from '../../../../share/config';
import session from '../../../../share/session';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import { getAbbrSysName } from '../../../../share/util/systemName';
import util from "../../../../share/util/utils";
const DiagSystemUtils = require('../../../../common/nodejs/diagSystemUtils');

/** 各フェーズ定義 */
const PHASE = {
  START: "start",
  CHECK: "check",
  EXECUTE: "execute",
  REGISTER: "register",
  FINISH: "finish",
  TIMEOUT: "timeout",
  AGAIN: "again",
  ERROR: "error",
  END: "end"
};

/** API type定義 */
const API_TYPE = {
  STANDBY: 'standby',
  READ: 'read',
  EXECUTE: 'execute',
  READ_SPECIAL: 'read_special',
  START: 'start',
  STOP: 'stop',
  TERMINATE: 'terminate',
};


export default {
  name: "requirement082",
  data() {
    return {
      phase: PHASE.START,
      isLoading: false,
      displayInfo: "",
      waitTime: 0,
      // 時間計測中かどうかのフラグ
      isProcessingMeatureTime: false,
      // stopAPIを実行済みかどうかのフラグ
      alreadyStopped: false,
      // stopAPIを実行中かどうかのフラグ
      isStopProcessing: false,
      timer: undefined,
      modal_requirement_082: false,
      uniqueErrorMsg: ''
    };
  },

  props: {
    i18nWsKey: { type: String, default: "", required: true },
    workSupportId: { type: Number, default: "", required: true }
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId
    }),
    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.TIMEOUT:
        case PHASE.ERROR:
        case PHASE.AGAIN:
          return "danger";
        case PHASE.END:
          return "success";
        case PHASE.START:
        case PHASE.CHECK:
        case PHASE.EXECUTE:
        case PHASE.REGISTER:
        case PHASE.FINISH:
        default:
          return "secondary";
      }
    }
  },

  methods: {
    ...mapActions("auth", ["logout", "resetSession"]),

    /** 初期化処理 */
    init() {
      this.modal_requirement_082 = true;
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit("close-wizard");
      this.modal_requirement_082= false;
    },

    /** その他エラー発生時の表示 */
    showUnexpectedError() {
      // 共通エラー画面の場合は、ウィザードを閉じる
      if (this.phase === PHASE.ERROR) {
        this.closeWizard();
        return;
      }
      this.isLoading = false;
      // 異常終了：エラー表示
      this.phase = PHASE.ERROR;
    },

    /**
     * API 通信で共通バリデーションでエラーが発生した際のコールバック
     * @param {object} result バリデーション結果
     */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /** 登録モード遷移 */
    async transitionRegisterMode() {
      try {
        this.isLoading = true;

        // 準備処理
        if (!await this.doStandby()) {
          return;
        }

        // キー状態判定
        if (!await this.doRead()) {
          return;
        }

        // ルーチン実行
        if (!await this.doExecute()) {
          return;
        }

        this.isProcessingMeatureTime = true;

        // データ読み出し
        if (!await this.doReadSpecial()) {
          return;
        }

        // 時間を計測
        await this.meatureTime();

      } finally {
        // stop処理が実行中でない場合にローディングを停止する
        if (!this.isStopProcessing) {
          this.isLoading = false;
        }
      }
    },

    /** 時間を計測 */
    async meatureTime() {
      this.timer = setTimeout(this.transitionTimeout, this.waitTime);

      while (this.isProcessingMeatureTime) {
        // データ読み出し
        if (!await this.doReadSpecial()) {
          this.isProcessingMeatureTime = false;
          break;
        }
        await util.sleep(process.env.VUE_APP_RETRY_INTERVAL);
      }
    },

    /** 計測時間到達時の処理 */
    async transitionTimeout() {
      // 時間計測を終了する
      this.isProcessingMeatureTime = false;
      // タイムアウト画面へ遷移
      this.phase = PHASE.TIMEOUT;

      // 終了処理
      if (!this.alreadyStopped) {
        this.alreadyStopped = true;
        if (!await this.doStop()) {
          return;
        }

        this.doTerminate();
      }
    },

    /** 準備処理 */
    async doStandby() {
      // API実行パラメータ作成
      const systemId = individualDiagnose.getCurrentSystemId(this);
      const token = session.getToken();
      const requestBody = {
        id_token: token.id_token,
        type: API_TYPE.STANDBY
      };

      // standby API実行
      const response = await individualWorkSupportUtil.pollingWspApi(
        this,
        this.netAppId,
        systemId,
        this.workSupportId,
        requestBody,
        // エラー発生のコールバック
        (errorType) => { errorType; this.showUnexpectedError(); },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
      );

      let isSuccess = false;

      if (response) {
        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            // 正常終了
            this.phase = PHASE.CHECK;
            isSuccess = true;
            break;
          case config.STATUS_WSP_FAILED:
          default:
            // 異常終了
            this.showUnexpectedError();
            break;
        }
      }

      return isSuccess;
    },

    /** キー状態判定 */
    async doRead() {
      // API実行パラメータ作成
      const systemId = individualDiagnose.getCurrentSystemId(this);
      const token = session.getToken();
      const requestBody = {
        id_token: token.id_token,
        type: API_TYPE.READ
      };

      // read API実行
      const response = await individualWorkSupportUtil.pollingWspApi(
        this,
        this.netAppId,
        systemId,
        this.workSupportId,
        requestBody,
        // エラー発生のコールバック
        (errorType) => { errorType; this.showUnexpectedError(); },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
      );

      let isSuccess = false;

      if (response) {
        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            // 正常終了
            this.phase = PHASE.EXECUTE;
            isSuccess = true;
            break;
          case config.STATUS_WSP_FAILED:
          default:
            // 異常終了
            this.showUnexpectedError();
            break;
        }
      }

      return isSuccess;
    },

    /** 登録モード遷移-ルーチン実行 */
    async doExecute() {
      // API実行パラメータ作成
      const systemId = individualDiagnose.getCurrentSystemId(this);
      const token = session.getToken();
      const requestBody = {
        id_token: token.id_token,
        type: API_TYPE.EXECUTE
      };

      // execute API実行
      const response = await individualWorkSupportUtil.pollingWspApi(
        this,
        this.netAppId,
        systemId,
        this.workSupportId,
        requestBody,
        // エラー発生のコールバック
        (errorType) => { errorType; this.showUnexpectedError(); },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
      );

      let isSuccess = false;

      if (response) {
        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            // 正常終了
            isSuccess = true;
            break;
          case config.STATUS_WSP_FAILED:
          default:
            // 異常終了
            this.showUnexpectedError();
            break;
        }
      }

      return isSuccess;
    },

    /** 登録モード遷移-データ読み出し */
    async doReadSpecial() {
      // API実行パラメータ作成
      const systemId = individualDiagnose.getCurrentSystemId(this);
      const token = session.getToken();
      const requestBody = {
        id_token: token.id_token,
        type: API_TYPE.READ_SPECIAL
      };

      // read API実行
      const response = await individualWorkSupportUtil.pollingWspApi(
        this,
        this.netAppId,
        systemId,
        this.workSupportId,
        requestBody,
        // エラー発生のコールバック
        (errorType) => { errorType; this.showUnexpectedError(); },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
      );

      // 時間計測が終了した後にレスポンスが来ても無視する
      if (!this.isProcessingMeatureTime) {
        return true;
      }

      let isSuccess = false;

      if (response) {
        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            // 正常終了
            // 表示する内容を控えておく
            this.displayInfo = this.$t(`${this.i18nWsKey}.REQ_WS_82_TXT_4_0002`).replace('$DID$', response.data.user_data.record_number);
            this.waitTime = response.data.user_data.wait_time;
            this.phase = PHASE.REGISTER;
            isSuccess = true;
            break;
          case config.STATUS_WSP_FAILED:
            switch (response.data.async_code) {
              case error.WSP_082_READ_SPECIAL_FAILED:
                // 独自エラー
                this.movePhaseAgain();
                break;
              default:
                this.showUnexpectedError();
                break;
            }
            break;
          default:
            // 異常終了
            this.showUnexpectedError();
            break;
        }
      }

      return isSuccess;
    },

    /** 停止処理 */
    async doStop() {
      try {
        this.isStopProcessing = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.STOP
        };

        // stop API実行
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        let isSuccess = false;

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了
              isSuccess = true;
              break;
            case config.STATUS_WSP_FAILED:
              switch (response.data.async_code) {
                case error.WSP_082_STOP_FAILED:
                  // 独自エラー
                  this.isLoading = false;
                  this.movePhaseAgain();
                  break;
                default:
                  this.showUnexpectedError();
                  break;
              }
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }

        return isSuccess;

      } finally {
        this.isStopProcessing = false;
      }
    },

    /** 独自エラー(PHASE.AGAIN)に遷移する処理 */
    movePhaseAgain() {
      // システムによって独自エラーの翻訳文言が異なる為、判定を行う
      const systemId = individualDiagnose.getCurrentSystemId(this);
      this.uniqueErrorMsg = DiagSystemUtils.isBodyControlByAbbreviationId(getAbbrSysName(systemId)) ?
        this.$t(`${this.i18nWsKey}.REQ_WS_82_TXT_8`) : this.$t(`${this.i18nWsKey}.REQ_WS_82_TXT_8_0003`);

      // 異常終了(やり直し)画面に遷移する
      this.phase = PHASE.AGAIN;
    },

    /** 終了時の処理 */
    async doTerminate() {
      try {
        // stop処理の延長で実行される場合は、ローディングされたままになっている
        if (!this.isLoading) {
          this.isLoading = true;
        }

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.TERMINATE
        };

        // terminate API実行
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了
              if (this.phase === PHASE.ERROR || this.phase === PHASE.AGAIN) {
                // 共通エラー画面、異常終了(やり直し)画面の場合は、ウィザードを閉じる
                this.closeWizard();
              } else {
                this.phase = PHASE.END;
              }
              break;
            case config.STATUS_WSP_FAILED:
              if (this.phase === PHASE.ERROR) {
                // 共通エラー画面の場合は、ウィザードを閉じる
                this.closeWizard();
              } else {
                this.showUnexpectedError();
              }
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    // ユーザ操作
    /** 初期画面 OKボタン押下 */
    onStartOkClicked() {
      this.transitionRegisterMode();
    },

    /** 初期画面 キャンセルボタン押下 */
    onStartCancelClicked() {
      this.closeWizard();
    },

    /** 登録モード中画面 OKボタン押下 */
    async onRegisgerOkClicked() {
      this.phase = PHASE.FINISH;
      // 時間計測を終了する
      this.isProcessingMeatureTime = false;
      clearTimeout(this.timer);

      // タイムアウトしてstop処理が既に行われていたら、実行しない
      if (!this.alreadyStopped) {
        this.alreadyStopped = true;
        if (!await this.doStop()) {
          return;
        }

        this.doTerminate();
      }
    },

    /** 正常終了画面 OKボタン押下 */
    onSuccessOkClicked() {
      this.closeWizard();
    },

    /** 異常終了(やり直し)画面 OKボタン押下 */
    async onRetryOkClicked() {
      await this.doTerminate();
    },

    /** 共通エラー画面 OKボタン押下 */
    onErrorOkClicked() {
      this.doTerminate();
    }
  },

  async mounted() {
    this.init();
  }
};
